// @flow

import styled, { css } from "styled-components";

export const Container = styled.div`
  min-height: 100px;
  display: flex;
  flex-direction: column;
  ${(props) =>
    props.autoHeight &&
    css`
      flex: 1 0 0;
      display: flex;
      overflow-y: auto;
    `};
`;

export const InfoNChangesContainer = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
`;
